import { ACTIONS_LICENSE_TYPE } from '../_constants/licenseType.constants';

const initialState = {
  byId: {},
};

export function licenseTypeReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_LICENSE_TYPE.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_LICENSE_TYPE.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_LICENSE_TYPE.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default licenseTypeReducer;
